import React from 'react';
import HelpArticle from './HelpArticle';
import ServerStatusWidget from './ServerStatusWidget';

const SERVER_STATUS_NOTICE_ID = 'file-attachment-limit-2025-12';

const NoticeDetail = ({ item, backTo }) => (
  <HelpArticle tab="notice" backTo={backTo} date={item.date} title={item.title}>
    <div className="help-article__content" dangerouslySetInnerHTML={{ __html: item.content }} />
    {item.id === SERVER_STATUS_NOTICE_ID && (
      <div className="help-article__server-status">
        <ServerStatusWidget />
      </div>
    )}
  </HelpArticle>
);

export default NoticeDetail;
